export default {"src":"/_next/static/media/location_city.50a732b5.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};